// extracted by mini-css-extract-plugin
export default {"banner":"banner_banner__F7eHz","bannerTextContainer":"banner_bannerTextContainer__a6M7w","bannerText":"banner_bannerText__WscAm"};